<template>
    <div class="">
        <!-- <div class="uXMilnO">
        <Header @parterr="parterr" :upadteQuotaStatus="getUpadteQuotaStatus"></Header>
        </div> -->

        <div class="cont_m">
          <content_view id="gc95c2" ref="contentView">
            <template  slot="header">
                <div id="cdd8de" style="width: 100%;">
                 <tools id="g9a4e3" class="u35ff0" :config="$store.state.app.toolsConfig" @clickMenu="clickMenu" ref="tools">
          </tools>
                </div>
            </template>

        </content_view>
            <div style="display:flex;justify-content: end;margin-top: 4rem;">
                <Menu :percentageerr="percentageerr" v-if="$store.state.app.isMenu" :menuInfos="menuInfos" @getCurLink="getKey"></Menu>
                  <FilterMenu  v-if="!$store.state.app.isMenu" @FilterMenuObj="FilterMenuObj"></FilterMenu>
                <div class="right_box">
                    <router-view  ref="route" @upadteQuota="getUpdateQuato" />
                </div>
            </div>
            <!-- <PermissionDialog></PermissionDialog> -->
        </div>
    </div>
</template>
<script>

// import PermissionDialog from '@/components/power/PermissionDialog.vue';
import { getDashboard } from '@/api/userApi.js'
import Menu from './components/leftMenu.vue'
import FilterMenu from './components/FilterMenu.vue'
import Header from '../layout/header.vue'
import tools from "../company/component/tools.vue";
import content_view from "../layout/content_view.vue";
export default {
    components: { Header, Menu, tools,content_view,FilterMenu },
    data() {
        return {
            getUpadteQuotaStatus: false,
            dashboadObj: {},
            menuInfos: [],
            percentageerr: false,
            toolsConfig: {
        menu: {
          isShow: true,
          isActive: true,
        },

        filter: {
          isShow: false,
          isActive: false,
        },

        select: {
          isShow: true,
          isActive: false,
        },

        edit: {
          isShow: true,
          isActive: false,
        },

        sort: {
          isShow: true,
          isActive: false,
        },

        collect: {
          isShow: true,
          isActive: false,
        },

        saved: {
          isShow: true,
          isActive: false,
        },

        compare: {
          isShow: true,
          isActive: false,
        },

        export: {
          isShow: true,
          isActive: false,
        },

        download: {
          isShow: true,
          isActive: false,
        },

        update: {
          isShow: true,
          isActive: false,
        },

        reportError: {
          isShow: true,
          isActive: false,
        },

        share: {
          isShow: true,
          isActive: false,
        },
      },
        }
    },
    computed: {
    },
    created() {
         
        this.$store.dispatch("app/setThemColor", "#1290C9");
        this.$store.dispatch("app/setSearchType", "company");
        // this.dashboadInit()
        this.setToolsfalse()
    },
    methods: {
      FilterMenuObj(val){

        
         this.$refs.route.FilterObj = val;
        
      },
          clickMenu(name, data) {
           
      switch (name) {
        case "menu":
          this.$store.dispatch("app/toggleMenu", !this.$store.state.app.isMenu);
                this.$refs.route.FilterObj={}
          break;
        case "Sort":
          this.$refs.route.Sort = data;
          break;
        case "Saved":
          this.$refs.route.Saved = data;
          break;
        case "select":
          
          this.$nextTick(() => {
            if (this.$refs.route.isOpenSlct) {
              this.$refs.route.isOpenSlct = false;
              this.$refs.route.isOpenSlct = false;
            } else {
              this.$refs.route.isOpenSlct = true;
              this.$refs.route.isOpenSlct = true;
            }
          });
          break;
        case "Compare":
          this.$nextTick(() => {
            if (this.$refs.route.Compare) {
              this.$refs.route.Compare = false;
            } else {
              this.$refs.route.Compare = true;
            }
          });
          break;
        case "Export":
          this.$nextTick(() => {
            if (this.$refs.route.Export) {
              this.$refs.route.Export = false;
            } else {
              this.$refs.route.Export = true;
            }
          });
          break;
        case "Update":
          this.$nextTick(() => {
            if (this.$refs.route.Update) {
              this.$refs.route.Update = false;
            } else {
              this.$refs.route.Update = true;
            }
          });
          break;
        case "Report":
          this.$nextTick(() => {
            if (this.$refs.route.ReportError) {
              this.$refs.route.ReportError = false;
            } else {
              this.$refs.route.ReportError = true;
            }
          });
          break;
        case "Clearall":
          this.$nextTick(() => {
            if (this.$refs.route.Clearallflase) {
              this.$refs.route.Clearallflase = false;
            } else {
              this.$refs.route.Clearallflase = true;
            }
          });

          break;
     
        case "edit":
          this.$refs.route.columns = data;
          break;
      }
    }, // clearSearch
         setToolsfalse() {
          
      this.$store.dispatch("app/setTools", {

        name: "select",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {

        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "riskScanning",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "creditAssessment",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "dataAnalysis",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "customPortfolio",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "print",
        key: "isActive",
        value: false,
      });
       this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: false,
      });
    },
        parterr(value) {
            this.percentageerr = value
        },
        getUpdateQuato(val) {
            this.getUpadteQuotaStatus = val
        },

        getKey(val) {
            if (val === 0) {
                // this.dashboadInit()
            }
        }
    }
}
</script>
<style scoped>
@media screen and (max-width: 1441px) {

    .right_box {
        /* width: 82% ; */
        width: calc(100% - 27.5rem) !important;
    }
}

.right_box {
    /* width: 82% ; */
    float: right;
    width: calc(100% - 26rem);
}

.cont_m {
    background: #F5F5F5;
}

.uBmamJ5 {
    display: flex;
    align-items: center;
    height: 100%;
    box-sizing: border-box;
    color: rgb(255, 255, 255);
}
</style>